import React from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Chip from "@material-ui/core/Chip";
import * as Dati from "../../../Dati";
import { Trad } from "../../../components/";

const useStyles = makeStyles(({ spacing }: Theme) => ({
    root: {
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap",
        "& > *": {
            margin: spacing(0.5)
        }
    }
}));

interface IUserGroupsProps {
    Groups: Dati.Dictionary<boolean>;
    OnGroupChange: (key: string, val: boolean) => void;
}

export const _UserGroups: React.FC<IUserGroupsProps> = ({ Groups, OnGroupChange }) => {
    const classes = useStyles();

    return (
        <Card>
            <CardHeader title={Trad.Trad("Gruppi")} titleTypographyProps={{ variant: "h6" }} />
            <CardContent className={classes.root}>
                {Object.keys(Groups).map(key => {
                    return (
                        <Chip
                            variant={Groups[key] ? "default" : "outlined"}
                            key={key}
                            label={Trad.Trad(key)}
                            color={Groups[key] ? "secondary" : "default"}
                            onClick={() => OnGroupChange(key, !Groups[key])}
                        />
                    );
                })}
            </CardContent>
        </Card>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/User/UserGroups.tsx